import { useEffect, useState } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUpload, faDownload } from '@fortawesome/free-solid-svg-icons';

// import './downUpModal.css';

function downUpModal(props) {
    // list of Commands to be sent to remote computer 
    const [commands, setCommands] = useState([]);
    const [icon, setIcon] = useState(null);

    // Unique input id for input element
    const inputId = `${props.name}-listItem`;
    // Unique input id for ordered list element
    const listId = `${props.name}-list`;

    // Gets the unique input element in terminal modal
    const inputElm = document.getElementById(inputId);
    // Gets the unique ordered list element in terminal modal
    const listElm = document.getElementById(listId);
    // listElm.style.minHeight = "200px";
    // listElm.style.border = "1px white solid";
    // listElm.style.margin = "10px";

    // When the user clicks the button, open the modal 
    const openModal = () => {
        document.querySelector('.modal').style.display = "block";
        document.getElementById(props.name).classList.add('active');    }

    // When the user clicks on <span> (x), close the modal
    const closeModal = () => {
        document.querySelector(".modal").style.display = "none";
        document.getElementById(props.name).classList.remove('active');    }

    // If remote computer is a windwows pc launch the file picker
    const filePicker = async (ev) => {
        document.getElementById('filepicker').disabled = true;
        
        // Close Modal
        closeModal();

        const response = await axios.post(
            `${props.url}/api/filepicker`, 
            {}, 
            // Security Vulnerability
            { "headers": {"apiKey": props.apiKey}, "Content-Type": "multipart/form-data" }
        );

        const output = document.createElement("li");

        if(response.status === 200) {
            output.innerText = "Filepicker Success";
            output.style = "background-color: #2eb82e; list-style-type: none; text-align: center; padding: 5px; font-weight: 600; border-radius: 10px; margin-bottom: 5px;";
            document.getElementById("outputbox").appendChild(output);

            // console.log(response.data);
            document.getElementById('downloadpath').value = response.data.path;
            setTimeout(() => {
                document.getElementById('downloadbtn').click();
                document.getElementById('filepicker').disabled = false;
            }, 100);
        } else {
            output.innerText = "Filepicker Failed";
            output.style = "background-color: #ff3300; list-style-type: none; text-align: center; padding: 5px; font-weight: 600; border-radius: 10px; margin-bottom: 5px";
            document.getElementById("outputbox").appendChild(output);
        }
    }

    // Handles Uploading of files to remote computer
    const uploadFiles = async (ev) => {
        const files = document.getElementById("myfiles").files;
        console.log(files);
        const output = document.createElement("li");

        // Close Modal
        closeModal();

        if(files.length !== 0) {
            for(let i = 0; i < files.length; i++) {
                const bodyFormData = new FormData();
                bodyFormData.append('file', files[i]);
                const response = await axios.post(
                    `${props.url}/api/uploadfile`, 
                    bodyFormData, 
                    // Security Vulnerability
                    { "headers": {"apiKey": props.apiKey}, "Content-Type": "multipart/form-data", "timeout": 3600000 }
                );

                if(response.status === 200) {
                    output.innerText = "Upload Success";
                    output.style = "background-color: #2eb82e; list-style-type: none; text-align: center; padding: 5px; font-weight: 600; border-radius: 10px; margin-bottom: 5px;";
                    document.getElementById("outputbox").appendChild(output);
                    
                } else {
                    output.innerText = "Upload Failed";
                    output.style = "background-color: #ff3300; list-style-type: none; text-align: center; padding: 5px; font-weight: 600; border-radius: 10px; margin-bottom: 5px";
                    document.getElementById("outputbox").appendChild(output);
                }
            }
        }
    }

    // Handles Downloading files from remote computer
    const downloadFiles = async (ev) => {
        // Loads the file path to input element
        const fpath = document.getElementById("downloadpath").value;
        console.log(`download path: ${fpath}`);
        const splitFileName = fpath.split('\\');
        const fileName = splitFileName[splitFileName.length - 1];
        // console.log(fpath);
        // Transmit filepath of desired file on the server and download it to users computer
        try {
            const download = await axios(
                {
                    url: `${props.url}/api/downloadfile`, 
                    method: 'POST',
                    headers: {
                        // Security Problem
                        apiKey: props.apiKey
                    },
                    data: {
                        filepath: fpath
                    }, 
                    responseType: 'blob'
            });
            //console.log(download);

            const output = document.createElement("li");


            if(download.status === 200) {
                const url = window.URL.createObjectURL(new Blob([download.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName); //or any other extension
                document.body.appendChild(link);
                link.click();

                output.innerText = "Download Success";
                output.style = "background-color: #2eb82e; list-style-type: none; text-align: center; padding: 5px; font-weight: 600; border-radius: 10px; margin-bottom: 5px;";
                document.getElementById("outputbox").appendChild(output);
            } else {
                output.innerText = "Download Failed";
                output.style = "background-color: #ff3300; list-style-type: none; text-align: center; padding: 5px; font-weight: 600; border-radius: 10px; margin-bottom: 5px";
                document.getElementById("outputbox").appendChild(output);
            }
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        if(props.name.toLowerCase() === 'upload') {
            setIcon(faUpload);
        } else {
            setIcon(faDownload);
        }
    },[]);

    return(
        <>
        <button className='height-40px width-40px flex row justify-content-cntr align-items-cntr bg-color-background border rounded hover-cursor border-color-foreground' onClick={openModal} data-toggle="tooltip" data-placement="bottom" title="Download or Upload File"><FontAwesomeIcon icon={icon} size='2xl' color='white' /></button>
        {/* <li className="padding-xs bg-color-primary-2 hover-bg-primary-2 hover-cursor align-txt-cntr rounded margin-b-xs" onClick={openModal}>{props.name}</li> */}
        <div id={props.name} className="modal-overlay">
            <div id='modal-content' className="modal">
                <span className="close" onClick={closeModal}>&times;</span>
                <h2>{props.name}</h2>
                {props.name === "Download" 
                ? 
                <div className="input-group">
                    <input className='input' type="text" id="downloadpath" placeholder="enter file path"/>
                    <button className='button' id="downloadbtn" onClick={downloadFiles}>Download</button>
                    <button className='button' id="filepicker" onClick={filePicker}>File Picker</button>
                </div>
                :
                <div className="input-group">
                    <input className='input' type="text" id={inputId} placeholder="enter file path"/>
                    <input className='inputt' type="file" id="myfiles" name="filename" />
                    <button className='button' id="downBtn" onClick={uploadFiles}>Upload</button>
                </div>
                }
                {/* <div className="button-group">
                    <button id="exitBtn" onClick={closeModal}>Exit</button>
                    <button id="sendBtn" onClick={sendCommands}>Send</button>
                </div> */}
            </div>
        </div>
        </>
    );
}

export default downUpModal;